var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 14.25V15.9C6.375 16.11 6.375 16.215 6.33413 16.2952C6.29817 16.3658 6.24081 16.4232 6.17025 16.4591C6.09003 16.5 5.98502 16.5 5.775 16.5H4.35C4.13998 16.5 4.03497 16.5 3.95475 16.4591C3.88419 16.4232 3.82683 16.3658 3.79087 16.2952C3.75 16.215 3.75 16.11 3.75 15.9V14.25M14.25 14.25V15.9C14.25 16.11 14.25 16.215 14.2091 16.2952C14.1732 16.3658 14.1158 16.4232 14.0452 16.4591C13.965 16.5 13.86 16.5 13.65 16.5H12.225C12.015 16.5 11.91 16.5 11.8298 16.4591C11.7592 16.4232 11.7018 16.3658 11.6659 16.2952C11.625 16.215 11.625 16.11 11.625 15.9V14.25M2.25 9H15.75M2.25 4.125H15.75M4.875 11.625H6M12 11.625H13.125M5.85 14.25H12.15C13.4101 14.25 14.0402 14.25 14.5215 14.0048C14.9448 13.789 15.289 13.4448 15.5048 13.0215C15.75 12.5402 15.75 11.9101 15.75 10.65V5.1C15.75 3.83988 15.75 3.20982 15.5048 2.72852C15.289 2.30516 14.9448 1.96095 14.5215 1.74524C14.0402 1.5 13.4101 1.5 12.15 1.5H5.85C4.58988 1.5 3.95982 1.5 3.47852 1.74524C3.05516 1.96095 2.71095 2.30516 2.49524 2.72852C2.25 3.20982 2.25 3.83988 2.25 5.1V10.65C2.25 11.9101 2.25 12.5402 2.49524 13.0215C2.71095 13.4448 3.05516 13.789 3.47852 14.0048C3.95982 14.25 4.58988 14.25 5.85 14.25Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.e62446d4e2a90ae13d0849275930d3d4.svg";
export { ForwardRef as ReactComponent };